export default {
  name: 'modalsController',
  namespaced: true,
  state: {
    modals: [],
  },
  getters: {
    getModals(state) {
      return state.modals;
    },
  },
  actions: {
    SHOW({ commit }, { type, props }) {
      commit('ADD_MODAL', { type, props });
    },
    CLOSE({ commit }) {
      commit('REMOVE_MODAL');
    },
    CLOSE_ALL({ commit }) {
      commit('REMOVE_ALL');
    },
  },
  mutations: {
    ADD_MODAL(state, modal) {
      state.modals.push(modal);
    },
    REMOVE_MODAL(state) {
      state.modals.pop();
    },
    REMOVE_ALL(state) {
      state.modals = [];
    },
  },
};
